function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
//Material imports
import Typography from "@mui/material/Typography";
import FormHelperText from "@mui/material/FormHelperText";
import { emphasize } from "@mui/material/styles";
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { COMPONENTS } from "./AutoCompleteUIComponents";
import { withi18n } from "../../../../customer/components";
const inputStyles = (base, palette) => ({
  ...base,
  fontSize: "0.8125rem",
  color: palette.text.primary,
  "& input": {
    font: "inherit"
  }
});
const getStyles = (variant, {
  palette
}, disabled) => {
  const disabledColor = palette.action.disabled;
  const primaryStyles = {
    input: base => inputStyles(base, palette),
    dropdownIndicator: base => ({
      ...base,
      color: disabled ? disabledColor : palette.primary.dark,
      cursor: "pointer"
    }),
    clearIndicator: base => ({
      ...base,
      color: disabled ? disabledColor : palette.primary.dark,
      cursor: "pointer"
    }),
    label: {
      color: disabled ? disabledColor : palette.text.primary,
      fontSize: "0.8125rem",
      position: "relative",
      marginBottom: 3
    }
  };
  const alternativeStyles = {
    input: base => inputStyles(base, palette),
    dropdownIndicator: base => ({
      ...base,
      color: disabled ? disabledColor : palette.secondary.main,
      cursor: "pointer"
    }),
    clearIndicator: base => ({
      ...base,
      color: disabled ? disabledColor : palette.secondary.main,
      cursor: "pointer"
    }),
    label: {
      color: disabled ? disabledColor : palette.text.primary,
      fontSize: "0.8125rem",
      position: "relative",
      marginBottom: 3
    }
  };
  return variant === "primary" ? primaryStyles : alternativeStyles;
};
class AutoComplete extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleChange", value => {
      const {
        onChange,
        name,
        isMulti
      } = this.props;
      //to support react select v3 migration
      if (isMulti && !value) {
        onChange([], name);
      } else {
        onChange(value, name);
      }
    });
  }
  render() {
    const {
      t,
      classes,
      theme,
      suggestions,
      placeholder,
      label,
      id,
      loadingMessage,
      loading,
      disabled,
      isMandatory,
      error,
      helperText,
      containerStyles,
      variant,
      background,
      ...rest
    } = this.props;
    const selectStyles = getStyles(variant, theme, disabled);
    let borderClass = classes.border;
    if (background === "white") {
      borderClass = `${borderClass} ${classes.whiteBackground}`;
      classes.border = borderClass;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      color: "textPrimary",
      style: selectStyles.label,
      component: "label"
    }, t(label), " ", isMandatory && /*#__PURE__*/React.createElement("div", {
      className: classes.mandatory
    }, "*")), /*#__PURE__*/React.createElement("div", {
      className: `${classes.root} ${containerStyles}`,
      style: background ? {
        backgroundColor: background
      } : null
    }, /*#__PURE__*/React.createElement(Select, _extends({
      classes: classes,
      styles: selectStyles,
      options: suggestions,
      components: COMPONENTS,
      placeholder: placeholder ? t(placeholder) : t("Type to search {0}", label.toLowerCase()),
      id: id ? id : `${label.toLowerCase()}AutoComplete`,
      loadingMessage: () => loadingMessage ? t(loadingMessage) : t("Loading {0}...", label.toLowerCase())
    }, rest, {
      onChange: this.handleChange,
      isLoading: loading,
      isDisabled: disabled || loading,
      error: error
    }))), error && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, helperText));
  }
}
const styles = theme => ({
  root: {
    flexGrow: 1
  },
  wrapper: {
    flex: 1
  },
  input: {
    display: "flex",
    padding: 0,
    minHeight: 55,
    height: "auto",
    fontFamily: theme.typography.body2.fontFamily
  },
  singleSelectInput: {
    height: 55
  },
  dropdownCursor: {
    cursor: "pointer"
  },
  border: {
    borderRadius: 4,
    border: `${theme.palette.border} `
  },
  valueContainer: {
    display: "flex",
    flex: 1,
    alignSelf: "center",
    overflow: "hidden",
    paddingLeft: 10,
    lineHeight: 0
  },
  multiValueContainer: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    overflow: "hidden",
    paddingLeft: 10,
    flexWrap: "wrap"
  },
  chip: {
    margin: `${theme.spacing(0.5)} ${theme.spacing(0.25)}`,
    fontSize: 12,
    color: theme.palette.primary.text,
    wordBreak: "break-word",
    whiteSpace: "pre-wrap"
  },
  chipLabel: {
    // minHeight: 32,
    height: "unset",
    whiteSpace: "unset"
  },
  chipFocused: {
    backgroundColor: emphasize(theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`
  },
  placeholder: {
    position: "absolute",
    left: 12,
    fontSize: 14
  },
  paper: {
    zIndex: 200,
    marginTop: theme.spacing(1),
    display: "table",
    wordBreak: "break-word"
  },
  paperAbs: {
    position: "absolute",
    left: 0,
    right: 0,
    width: "fill-available"
  },
  paperFixed: {
    position: "fixed"
  },
  divider: {
    height: theme.spacing(2)
  },
  mandatory: {
    color: theme.palette.error.main,
    display: "inline-flex",
    position: "relative",
    bottom: 4,
    marginLeft: 3
  },
  whiteBackground: {
    backgroundColor: theme.background.paper
  },
  disabled: {
    color: theme.palette.action.disabled
  },
  singleValue: {
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
});
export default withStyles(styles, {
  withTheme: true
})(withi18n(AutoComplete));
AutoComplete.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  suggestions: PropTypes.array.isRequired,
  selectedItem: PropTypes.array,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  isMulti: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  label: PropTypes.string,
  loadingMessage: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  minMenuWidth: PropTypes.number,
  isMandatory: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  containerStyles: PropTypes.string,
  variant: PropTypes.string,
  background: PropTypes.string,
  isFixedPosition: PropTypes.bool
};
AutoComplete.defaultProps = {
  label: "",
  isMulti: false,
  loading: false,
  disabled: false,
  minMenuWidth: 200,
  isMandatory: false,
  error: false,
  helperText: "",
  isFixedPosition: false
};